import { memo, useEffect, useMemo, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';
const Tabs = memo(({
    t,
    modules
}) => {
    const [activeTab, setActiveTab] = useState("");
    const history = useHistory();
    const location = useLocation();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    const tabsItems = useMemo(() => {
        const tabs = [
            {
                key: "qr",
                title: "QR Code"
            },
            {
                key: "risk-customization",
                title: "Risk Customization"
            }
        ];
        
        if(modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('news_monitoring')) {
            tabs.push({
                key: "news-monitoring",
                title: "News Monitoring"
            });
        }

        return [
            ...tabs,
            {
                key: "routing",
                title: "Routing"
            },
            // {
            //     key: "email-settings",
            //     title: "Email Settings"
            // }
        ]
    }, [
        modules.featuresLoadingStatus
    ]);

    useEffect(() => {
        const tabKey = (new URLSearchParams(location.search)).get('tab');
        const tab = (tabsItems.find((tab) => tab.key === tabKey))?.key;

        if(!tab) {
            history.push({
                search: '?tab=qr'
            });
        }
        else{
            setActiveTab(tab);
        }
    }, [
        location.search,
        tabsItems
    ]);

    return (
        <div style={{
            backgroundColor: '#D1D2D6',
        }}>
            <Nav tabs className="custom-style-1">
                {
                    tabsItems.map((link) => {
                        return (
                            <NavItem 
                                className={isActiveTab(activeTab, link.key) ? 'active' : ''} 
                                key={link.key}
                            >
                                <NavLink
                                    className={isActiveTab(activeTab, link.key) ? 'active' : ''}
                                    onClick={() => history.push({
                                        search: '?tab=' + link.key
                                    })}
                                >
                                    {t(link.title)}
                                </NavLink>
                            </NavItem>
                        )
                    })
                }
            </Nav>
        </div>
    );
});

const mapStatetoProps = (state) => {
    const { Modules } = state;

    return {
        modules: Modules
    };
};


export default withNamespaces()(
    withRouter(connect(mapStatetoProps)(Tabs))
);
